var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "video",
      {
        ref: "videoPlayer",
        staticClass: "video-js",
        attrs: { playlist: _vm.playlist }
      },
      [
        _c("source", { attrs: { src: _vm.src, type: "video/mp4" } }),
        _vm._v(" "),
        _c("source", { attrs: { src: _vm.altSrc, type: "video/webm" } }),
        _vm._v(" "),
        _vm._m(0)
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "vjs-playlist" }),
    _vm._v(" "),
    _c("a", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isFullScreen,
          expression: "isFullScreen"
        }
      ],
      staticClass: "video-js__close-fs-btn",
      attrs: { href: "#" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.closeFullScreen.apply(null, arguments)
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "vjs-no-js" }, [
      _vm._v(
        "\n      To view this video please enable JavaScript, and consider upgrading to a\n      web browser that\n      "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://videojs.com/html5-video-support/",
            target: "_blank"
          }
        },
        [_vm._v("supports HTML5 video")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e3bdfbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e3bdfbe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VideoPlayer.vue
// module id = 518
// module chunks = 1